module.exports = __webpack_public_path__ + "static/media/CompleteCompliance.90945d49.svg";